<div style="display: inline-block" [style.width]="width">
  <span class="input-container psudo-dropdown" [style.width]="width">
    <input type="text" class="custom-input" [value]="value" (input)="textChanged($event)" (click)="toggleDropdown(type, $event)" />
    <div class="underline"></div>
  </span>

  <div *ngIf="visible" class="multi-select-background">
    <div class="multi-select-dialog" [style.width]="width"> 
      <input class="multi-select-search" *ngIf="showSearch" type="text" placeholder="Search..." [(ngModel)]="search" (ngModelChange)="searchChanged()" />
      <div class="multi-select-options">
        <label *ngFor="let option of options" class="multi-select-option"
               [hidden]="!option.visible"
               [class.multi-select-option-tree]="treeMode"
               [style.padding-left.px]="treeMode ? option.depth * 18 : null">
          <span *ngIf="treeMode && option.isParent" class="material-icons multi-select-tree-toggle" (click)="toggleExpand(option, $event)">{{ option.expanded ? 'expand_more' : 'chevron_right' }}</span>
          <span *ngIf="treeMode && !option.isParent" class="multi-select-tree-spacer"></span>
          <input type="checkbox" class="multi-select-checkbox" [checked]="option.selected" (change)="toggle(option.label)" />
          <span *ngIf="option.blockColor" class="status-block" [style.background-color]="option.blockColor"></span>
          {{option.label}}
          <br />
        </label>
      </div>
    </div>
  </div>
</div>